import axios from '@axios'

export default {
  uploadFile(model, field) {
    return axios.post(`upload/${model}`, field)
  },
}
